<template>
  <v-app>
    <v-app-bar
        app
        dense
        style="background-color: black;  text-align: center"
        class="text-center"

        elevate-on-scroll
    >
      <v-tabs
          centered
          show-arrows
      >
        <v-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :to="tab.to"
            :disabled="tab.disabled"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </v-app-bar>

    <v-main
      style="background-color: black;"
    >
      <v-fab-transition
        duration="200"
      >
        <router-view />
      </v-fab-transition>
    </v-main>
    <v-footer app bottom fixed padless
      class="noselect"
    >
      <v-col
          class="text-center"
          cols="12"
      >
        © {{ new Date().getFullYear() }} — <strong>Arne Reckhaus</strong>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="ml-1"
                color="blue"
                dark
                v-bind="attrs"
                v-on="on"
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>Wilkommen bei mir! Über diese Seite verwalte ich mein Smarthome und teste neue Frameworks.</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="ml-2"
                color="grey"
                dark
                small
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/dev')"
            >
              mdi-code-tags
            </v-icon>
          </template>
          <span>Entwickler</span>
        </v-tooltip>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { vacuumApi } from "@/services/vacuum";
export default {
  //https://www.falstad.com/circuit/circuitjs.html?ctz=CQAgjCAMB0l3BWcMBMcUHYMGZIA4UA2ATmIxAQBYKLIKBTAWjDACgA3ER4w8YlLjxCU8UcMLopcYujAQdBvMPxDYBuanQiVJ0ybGKVsxBGEhTi2ZQmxRo8ztyUrGKHasibx7qbOHQwPDwMYnNPDDxCY0gkOVYAB0VhUTUPaggBSASuNzoNVXVPcUzsp2Sc93yMqFYAdyTlATBnEvqykXAUUQ6sgCcKMAEOhBUe5Hg6kDRRRvAWmvqRodElkDxZSdNlgYF1msTVva21rSn9ihVsBAFjq6azrMXBgrpb64WL9TRP1Xe+nZePzUfjMEwOKi6K2ekOKH2OKAQvHhQThEMRPxh-3h6NWCN4WngjyB31xKKJh1eKlm5KpEPwfFaP1muPRRMG3Sh2yJrkqRR5eT+kxEeSKwqmZKFexhyNEROw2F4+XlvDxH1Vdym6NVcoVaQKeqJYqVuvy3NyvwE6sF9StN2eGv+qvVuu1U0JrAA9uJCF4dMRRD7ZAExEpVA8zrYrmIo9hWEA
  data: () => ({
  }),
  computed: {
    tabs() {
      // Es gibt keinen Login mehr — Zugriffsschutz macht nginx, das /api/ aufs
      // Heimnetz beschränkt. localNetwork (Ping auf /api/vacuum/status in
      // created()) ist damit das einzige Gate: alles außer Home braucht das
      // Backend und ist von außen ohnehin 403.
      const local = this.$store.state.general.localNetwork
      return [
        {title: "Home", to: "/", disabled: false},
        {title: "Smarthaus", to: "/smarthaus", disabled: !local},
        {title: "Kanban", to: "/kanban", disabled: !local},
        // TODO: für /workflow existiert noch keine Route in src/router/index.js
        {title: "Workflows", to: "/workflow", disabled: true},
        {title: "Monitor", to: "/monitor", disabled: !local},
      ]
    },
  },
  created() {
    this.$store.commit('reset')
    vacuumApi.ping()
      .then(() => this.$store.commit('update_general_localNetwork', true))
      .catch(() => this.$store.commit('update_general_localNetwork', false))
  },
}
// color: #2c3e50;
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #3e5573;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>
